import AWS from "aws-sdk";
import uuidv4 from "uuid/v4";
import { ACCESS_KEY_ID, SECRET_ACCESS_KEY, TRACKING_ID } from "../constants";

const PersonalizeRecord = ({ eventType, userId, itemId, eventValue }) => {
  const AWSPersonalize = new AWS.PersonalizeEvents({
    apiVersion: '2018-05-22',
    accessKeyId: ACCESS_KEY_ID,
    secretAccessKey: SECRET_ACCESS_KEY,
    region: 'ap-southeast-1',
  });
  const recordParams = {
    eventList: [ /* required */
      {
        eventType, /* required */
        sentAt: new Date, /* required */
        properties: {
          eventValue,
          userId,
        } /* This value will be JSON encoded on your behalf with JSON.stringify() */,
        itemId
      },
      /* more items */
    ],
    sessionId: uuidv4(), /* required */
    trackingId: TRACKING_ID, /* required */
    userId,
  }

  AWSPersonalize.putEvents(recordParams, function (err, data) {
    if (err) console.log("ERROR RESPONSE PUT EVENTS", err, err.stack); // an error occurred
    else console.log("SUCCESS RESPONSE PUT EVENTS", data);           // successful response
  });
}

export default PersonalizeRecord;